import { merge } from 'lodash'
import Agent from './Agent'
import Alert from './Alert'
import AudioStream from './AudioStream'
import Debug from './Debug'
import Modal from './Modal'
import Note from './Note'
import NotesList from './NotesList'
import Schedule from './Schedule'
import Section from './Section'
import Toast from './Toast'
import WorkerStream from './WorkerStream'
import Veil from './Veil'

const resolvers = {}

merge(
  resolvers,
  Agent,
  Alert,
  AudioStream,
  Debug,
  Modal,
  Note,
  NotesList,
  Schedule,
  Section,
  Toast,
  WorkerStream,
  Veil
)

export default resolvers
